var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 134,
    viewBox: "0 0 133 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5137_19431)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.8236 41.536L91.3869 39.8084L82.7138 38.0637L80.634 31.238L78.5481 38.0637L69.875 39.8084L78.4383 41.536L80.634 48.7242L82.8236 41.536Z",
    fill: "#CCEFDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5938 95.0109L47.4147 94.1291L43.548 93.2366L42.6214 89.7625L41.6948 93.2366L37.8281 94.1291L41.6376 95.0109L42.6214 98.6657L43.5938 95.0109Z",
    fill: "#00C65E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9408 66.1844L90.569 66.1465C88.6617 65.9295 80.0902 65.3998 76.5042 60.567C74.2981 57.6193 74.9304 45.2893 74.9304 45.2893L60.8444 45.8815C60.8444 45.8815 57.366 61.4038 56.8831 71.0485C56.8775 71.2102 56.8817 71.372 56.8956 71.5331C56.9087 72.5351 57.3168 73.4913 58.0311 74.194C58.7455 74.8967 59.7084 75.289 60.7104 75.2855L90.481 74.5163C90.98 74.4972 91.4703 74.38 91.924 74.1714C92.3777 73.9628 92.7858 73.6668 93.1252 73.3004C93.4645 72.9341 93.7283 72.5045 93.9015 72.0361C94.0748 71.5678 94.1541 71.0699 94.1349 70.5709C94.0861 68.68 92.8316 66.4969 90.9408 66.1844Z",
    fill: "#FD9558"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.1057 57.8453C62.4005 53.1241 61.1537 51.9773 62.819 49.0817C64.4842 46.1861 69.8366 45.4107 70.6381 47.3583C72.0173 50.6887 68.3124 55.9761 69.6243 61.1149C70.9361 66.2537 73.9058 65.6349 77.3692 66.4583C80.8326 67.2816 86.1612 69.6352 85.7069 72.6611C85.4302 74.4654 82.9915 77.9705 78.2301 77.6942C74.5161 77.4764 70.3497 73.7331 66.9802 73.2306C63.6106 72.7281 57.9539 72.028 58.5444 66.5453C59.168 60.8716 60.0724 61.6469 61.1057 57.8453Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3152 74.4289L57.6582 75.2986L57.7603 79.2515L91.4173 78.3819L91.3152 74.4289Z",
    fill: "#FFB762",
    stroke: "#F79358",
    strokeWidth: 1.28152,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8416 82.3581C59.7728 82.3082 61.298 80.7022 61.2481 78.771C61.1982 76.8397 59.5921 75.3146 57.6609 75.3645C55.7296 75.4144 54.2045 77.0204 54.2544 78.9517C54.3043 80.8829 55.9104 82.408 57.8416 82.3581Z",
    fill: "white",
    stroke: "#2BAA51",
    strokeWidth: 1.28152,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8943 81.4785C93.8256 81.4286 95.3507 79.8226 95.3008 77.8913C95.2509 75.9601 93.6449 74.4349 91.7136 74.4848C89.7824 74.5347 88.2573 76.1408 88.3072 78.072C88.3571 80.0033 89.9631 81.5284 91.8943 81.4785Z",
    fill: "#FFB762"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7381 82.323C92.6693 82.2731 94.1945 80.667 94.1446 78.7358C94.0947 76.8046 92.4886 75.2794 90.5574 75.3293C88.6261 75.3792 87.101 76.9853 87.1509 78.9165C87.2008 80.8478 88.8068 82.3729 90.7381 82.323Z",
    fill: "#F69258"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5506 81.7715C82.4818 81.7216 84.007 80.1155 83.9571 78.1843C83.9072 76.253 82.3011 74.7279 80.3699 74.7778C78.4386 74.8277 76.9135 76.4337 76.9634 78.365C77.0133 80.2962 78.6193 81.8214 80.5506 81.7715Z",
    fill: "#FFB762"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3943 82.616C81.3256 82.5661 82.8507 80.96 82.8008 79.0288C82.7509 77.0975 81.1449 75.5724 79.2136 75.6223C77.2824 75.6722 75.7573 77.2782 75.8072 79.2095C75.8571 81.1407 77.4631 82.6659 79.3943 82.616Z",
    fill: "#F69258"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9186 53.3627L67.7539 53.5479L67.79 54.9447L74.9547 54.7596L74.9186 53.3627Z",
    fill: "#FD9558",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1971 82.0647C71.1283 82.0148 72.6534 80.4087 72.6035 78.4775C72.5536 76.5463 70.9476 75.0211 69.0164 75.071C67.0851 75.1209 65.56 76.727 65.6099 78.6582C65.6598 80.5895 67.2658 82.1146 69.1971 82.0647Z",
    fill: "white",
    stroke: "#2BAA51",
    strokeWidth: 1.28152,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1311 60.1676L67.9306 60.3795L67.8945 58.9827L75.6484 58.7823L76.1311 60.1676Z",
    fill: "#FD9558",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8029 73.6196L74.4469 73.5059C72.6253 72.9003 64.3473 70.6148 61.8347 65.1465C60.2837 61.8073 63.4445 49.8726 63.4445 49.8726L49.5391 47.5479C49.5391 47.5479 42.9351 62.0196 40.4741 71.3575C40.4353 71.5145 40.406 71.6737 40.3864 71.8342C40.1927 72.8174 40.3948 73.8372 40.949 74.6721C41.5031 75.5069 42.3644 76.0893 43.3456 76.2926L72.6352 81.6777C73.1274 81.7619 73.6314 81.7483 74.1183 81.6377C74.6053 81.5271 75.0657 81.3217 75.4732 81.0332C75.8808 80.7446 76.2275 80.3786 76.4936 79.9561C76.7597 79.5335 76.9399 79.0627 77.0241 78.5705C77.3661 76.7101 76.5887 74.3152 74.8029 73.6196Z",
    fill: "#FFB762"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.3282 59.3087C49.5685 54.9559 48.585 53.5766 50.8115 51.0866C53.038 48.5965 58.4352 48.9413 58.8179 51.0123C59.4809 54.5555 54.7655 58.9655 54.9897 64.2643C55.2139 69.5631 58.2473 69.57 61.4666 71.0897C64.6858 72.6094 69.4147 76.011 68.3462 78.8783C67.7035 80.5868 64.5945 83.5138 59.9924 82.2617C56.4031 81.2829 53.098 76.761 49.9044 75.5746C46.7109 74.3882 41.3201 72.5369 43.0283 67.2937C44.8083 61.8704 45.5333 62.8156 47.3282 59.3087Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4706 81.764L40.3574 75.6758L39.6424 79.5649L72.7556 85.6531L73.4706 81.764Z",
    fill: "#F89358",
    stroke: "#FFB762",
    strokeWidth: 1.28152,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0815 82.6218C40.9815 82.9712 42.805 81.7141 43.1544 79.8141C43.5037 77.914 42.2466 76.0905 40.3466 75.7412C38.4465 75.3918 36.6231 76.6489 36.2737 78.549C35.9244 80.449 37.1815 82.2725 39.0815 82.6218Z",
    fill: "#F69257"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5854 88.782C74.4854 89.1313 76.3089 87.8743 76.6583 85.9742C77.0076 84.0742 75.7505 82.2507 73.8505 81.9013C71.9504 81.552 70.127 82.8091 69.7776 84.7091C69.4283 86.6092 70.6854 88.4327 72.5854 88.782Z",
    fill: "#F69257"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4233 86.7293C63.3233 87.0786 65.1468 85.8215 65.4962 83.9215C65.8455 82.0214 64.5884 80.1979 62.6884 79.8486C60.7883 79.4993 58.9648 80.7564 58.6155 82.6564C58.2662 84.5564 59.5233 86.3799 61.4233 86.7293Z",
    fill: "#F69257"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2534 84.6756C52.1534 85.0249 53.9769 83.7678 54.3262 81.8678C54.6756 79.9677 53.4185 78.1442 51.5185 77.7949C49.6184 77.4456 47.7949 78.7026 47.4456 80.6027C47.0962 82.5027 48.3533 84.3262 50.2534 84.6756Z",
    fill: "#F69257"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7696 57.7701L54.7207 56.4741L54.468 57.8484L61.517 59.1444L61.7696 57.7701Z",
    fill: "#FFB762",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5536 64.6789L53.4856 63.1956L53.7383 61.8213L61.3668 63.2239L61.5536 64.6789Z",
    fill: "#FFB762",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8236 41.536L91.3869 39.8084L82.7138 38.0637L80.634 31.238L78.5481 38.0637L69.875 39.8084L78.4383 41.536L80.634 48.7242L82.8236 41.536Z",
    fill: "#CCEFDB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5938 95.0109L47.4147 94.1291L43.548 93.2366L42.6214 89.7625L41.6948 93.2366L37.8281 94.1291L41.6376 95.0109L42.6214 98.6657L43.5938 95.0109Z",
    fill: "#00C65E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9408 66.1844L90.569 66.1465C88.6617 65.9295 80.0902 65.3998 76.5042 60.567C74.2981 57.6193 74.9304 45.2893 74.9304 45.2893L60.8444 45.8815C60.8444 45.8815 57.366 61.4038 56.8831 71.0485C56.8775 71.2102 56.8817 71.372 56.8956 71.5331C56.9087 72.5351 57.3168 73.4913 58.0311 74.194C58.7455 74.8967 59.7084 75.289 60.7104 75.2855L90.481 74.5163C90.98 74.4972 91.4703 74.38 91.924 74.1714C92.3777 73.9628 92.7858 73.6668 93.1252 73.3004C93.4645 72.9341 93.7283 72.5045 93.9015 72.0361C94.0748 71.5678 94.1541 71.0699 94.1349 70.5709C94.0861 68.68 92.8316 66.4969 90.9408 66.1844Z",
    fill: "#FD9558"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.1057 57.8453C62.4005 53.1241 61.1537 51.9773 62.819 49.0817C64.4842 46.1861 69.8366 45.4107 70.6381 47.3583C72.0173 50.6887 68.3124 55.9761 69.6243 61.1149C70.9361 66.2537 73.9058 65.6349 77.3692 66.4583C80.8326 67.2816 86.1612 69.6352 85.7069 72.6611C85.4302 74.4654 82.9915 77.9705 78.2301 77.6942C74.5161 77.4764 70.3497 73.7331 66.9802 73.2306C63.6106 72.7281 57.9539 72.028 58.5444 66.5453C59.168 60.8716 60.0724 61.6469 61.1057 57.8453Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3152 74.4289L57.6582 75.2986L57.7603 79.2515L91.4173 78.3819L91.3152 74.4289Z",
    fill: "#FFB762",
    stroke: "#F79358",
    strokeWidth: 1.28152,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8416 82.3581C59.7728 82.3082 61.298 80.7022 61.2481 78.771C61.1982 76.8397 59.5921 75.3146 57.6609 75.3645C55.7296 75.4144 54.2045 77.0204 54.2544 78.9517C54.3043 80.8829 55.9104 82.408 57.8416 82.3581Z",
    fill: "white",
    stroke: "#2BAA51",
    strokeWidth: 1.28152,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8943 81.4785C93.8256 81.4286 95.3507 79.8226 95.3008 77.8913C95.2509 75.9601 93.6449 74.4349 91.7136 74.4848C89.7824 74.5347 88.2573 76.1408 88.3072 78.072C88.3571 80.0033 89.9631 81.5284 91.8943 81.4785Z",
    fill: "#FFB762"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7381 82.323C92.6693 82.2731 94.1945 80.667 94.1446 78.7358C94.0947 76.8046 92.4886 75.2794 90.5574 75.3293C88.6261 75.3792 87.101 76.9853 87.1509 78.9165C87.2008 80.8478 88.8068 82.3729 90.7381 82.323Z",
    fill: "#F69258"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5506 81.7715C82.4818 81.7216 84.007 80.1155 83.9571 78.1843C83.9072 76.253 82.3011 74.7279 80.3699 74.7778C78.4386 74.8277 76.9135 76.4337 76.9634 78.365C77.0133 80.2962 78.6193 81.8214 80.5506 81.7715Z",
    fill: "#FFB762"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3943 82.616C81.3256 82.5661 82.8507 80.96 82.8008 79.0288C82.7509 77.0975 81.1449 75.5724 79.2136 75.6223C77.2824 75.6722 75.7573 77.2782 75.8072 79.2095C75.8571 81.1407 77.4631 82.6659 79.3943 82.616Z",
    fill: "#F69258"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9186 53.3627L67.7539 53.5479L67.79 54.9447L74.9547 54.7596L74.9186 53.3627Z",
    fill: "#FD9558",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1971 82.0647C71.1283 82.0148 72.6534 80.4087 72.6035 78.4775C72.5536 76.5463 70.9476 75.0211 69.0164 75.071C67.0851 75.1209 65.56 76.727 65.6099 78.6582C65.6598 80.5895 67.2658 82.1146 69.1971 82.0647Z",
    fill: "white",
    stroke: "#2BAA51",
    strokeWidth: 1.28152,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1311 60.1676L67.9306 60.3795L67.8945 58.9827L75.6484 58.7823L76.1311 60.1676Z",
    fill: "#FD9558",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8029 73.6196L74.4469 73.5059C72.6253 72.9003 64.3473 70.6148 61.8347 65.1465C60.2837 61.8073 63.4445 49.8726 63.4445 49.8726L49.5391 47.5479C49.5391 47.5479 42.9351 62.0196 40.4741 71.3575C40.4353 71.5145 40.406 71.6737 40.3864 71.8342C40.1927 72.8174 40.3948 73.8372 40.949 74.6721C41.5031 75.5069 42.3644 76.0893 43.3456 76.2926L72.6352 81.6777C73.1274 81.7619 73.6314 81.7483 74.1183 81.6377C74.6053 81.5271 75.0657 81.3217 75.4732 81.0332C75.8808 80.7446 76.2275 80.3786 76.4936 79.9561C76.7597 79.5335 76.9399 79.0627 77.0241 78.5705C77.3661 76.7101 76.5887 74.3152 74.8029 73.6196Z",
    fill: "#FFB762"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.3282 59.3087C49.5685 54.9559 48.585 53.5766 50.8115 51.0866C53.038 48.5965 58.4352 48.9413 58.8179 51.0123C59.4809 54.5555 54.7655 58.9655 54.9897 64.2643C55.2139 69.5631 58.2473 69.57 61.4666 71.0897C64.6858 72.6094 69.4147 76.011 68.3462 78.8783C67.7035 80.5868 64.5945 83.5138 59.9924 82.2617C56.4031 81.2829 53.098 76.761 49.9044 75.5746C46.7109 74.3882 41.3201 72.5369 43.0283 67.2937C44.8083 61.8704 45.5333 62.8156 47.3282 59.3087Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4706 81.764L40.3574 75.6758L39.6424 79.5649L72.7556 85.6531L73.4706 81.764Z",
    fill: "#F89358",
    stroke: "#FFB762",
    strokeWidth: 1.28152,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0815 82.6218C40.9815 82.9712 42.805 81.7141 43.1544 79.8141C43.5037 77.914 42.2466 76.0905 40.3466 75.7412C38.4465 75.3918 36.6231 76.6489 36.2737 78.549C35.9244 80.449 37.1815 82.2725 39.0815 82.6218Z",
    fill: "#F69257"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5854 88.782C74.4854 89.1313 76.3089 87.8743 76.6583 85.9742C77.0076 84.0742 75.7505 82.2507 73.8505 81.9013C71.9504 81.552 70.127 82.8091 69.7776 84.7091C69.4283 86.6092 70.6854 88.4327 72.5854 88.782Z",
    fill: "#F69257"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4233 86.7293C63.3233 87.0786 65.1468 85.8215 65.4962 83.9215C65.8455 82.0214 64.5884 80.1979 62.6884 79.8486C60.7883 79.4993 58.9648 80.7564 58.6155 82.6564C58.2662 84.5564 59.5233 86.3799 61.4233 86.7293Z",
    fill: "#F69257"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2534 84.6756C52.1534 85.0249 53.9769 83.7678 54.3262 81.8678C54.6756 79.9677 53.4185 78.1442 51.5185 77.7949C49.6184 77.4456 47.7949 78.7026 47.4456 80.6027C47.0962 82.5027 48.3533 84.3262 50.2534 84.6756Z",
    fill: "#F69257"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7696 57.7701L54.7207 56.4741L54.468 57.8484L61.517 59.1444L61.7696 57.7701Z",
    fill: "#FFB762",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5536 64.6789L53.4856 63.1956L53.7383 61.8213L61.3668 63.2239L61.5536 64.6789Z",
    fill: "#FFB762",
    stroke: "white",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5137_19431",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5137_19431"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_19431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_19431",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.ba79e1deb84a77a37103d12a18f2121b.svg";
export { ForwardRef as ReactComponent };